import apolloClient from 'apollo-client'
import {map, pick} from 'lodash'
import {
  CREATE_FULFILLMENT_LOCATIONS,
  DELETE_LOCATION,
  GET_FULFILLMENT_LOCATION,
  GET_LOCATIONS,
  REMOVE_FULFILLMENT_LOCATIONS,
  SAVE_MULTIPLE_FULFILLMENT_LOCATIONS,
  UPDATE_DEFAULT_LOCATION,
  UPDATE_FULFILLMENT_LOCATIONS,
} from './grapql'

export const mapToFulfillmentLocations = (values: any) => {
  const model = map(values, (user) =>
    pick(user, ['id', 'orderType', 'shippingLocationId', 'pickupLocationId'])
  )
  return model
}
class LocationService {
  async getFulfillmentLocation() {
    const {data} = await apolloClient.query({
      query: GET_FULFILLMENT_LOCATION,
    })
    return data.fulfillmentLocations.nodes
  }

  async getLocations() {
    const {data} = await apolloClient.query({
      query: GET_LOCATIONS,
    })
    return data.locations.nodes
  }

  async deleteLocation(id: string) {
    await apolloClient.mutate({
      mutation: DELETE_LOCATION,
      variables: {id},
    })
  }

  async updateDefaultLocation(id: string) {
    await apolloClient.mutate({
      mutation: UPDATE_DEFAULT_LOCATION,
      variables: {id},
    })
  }

  async createFulfillmentLocations(params: any) {
    await apolloClient.mutate({
      mutation: CREATE_FULFILLMENT_LOCATIONS,
      variables: params,
    })
  }

  async updateFulfillmentLocations(params: any) {
    await apolloClient.mutate({
      mutation: UPDATE_FULFILLMENT_LOCATIONS,
      variables: {fulfillmentLocations: mapToFulfillmentLocations(params)},
    })
  }

  async removeFulfillmentLocations(ids: any[]) {
    await apolloClient.mutate({
      mutation: REMOVE_FULFILLMENT_LOCATIONS,
      variables: {ids},
    })
  }

  async saveMultipleFulfillmentLocations(locationIds: string[], orderType: string) {
    await apolloClient.mutate({
      mutation: SAVE_MULTIPLE_FULFILLMENT_LOCATIONS,
      variables: {locationIds, orderType},
    })
  }
}

const locationService = new LocationService()
export default locationService
